import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_APP_ADMIN_TOOLS = `${URL_APP_ADMIN}/tools`

// Enterprise Status Page Routes
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE = `${URL_APP_ADMIN_TOOLS}/enterprise-status-page`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/create-incident`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/incident/:incidentId`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/user-groups`

// Caper Billing Routes
const URL_APP_ADMIN_CAPER_BILLING = `${URL_APP_ADMIN_TOOLS}/caper-billing`
const URL_APP_ADMIN_CAPER_BILLING_UPLOAD = `${URL_APP_ADMIN_CAPER_BILLING}/upload`
const URL_APP_ADMIN_CAPER_BILLING_HISTORY = `${URL_APP_ADMIN_CAPER_BILLING}/history`

// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  | 'app-admin-enterprise-status-page'
  | 'app-admin-enterprise-status-page-create-incident'
  | 'app-admin-enterprise-status-page-incident-details'
  | 'app-admin-enterprise-status-page-user-groups'
  | 'app-admin-caper-billing'
  | 'app-admin-caper-billing-upload'
  | 'app-admin-caper-billing-history'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-enterprise-status-page': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE,
  'app-admin-enterprise-status-page-create-incident':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT,
  'app-admin-enterprise-status-page-incident-details':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_INCIDENT_DETAILS,
  'app-admin-enterprise-status-page-user-groups': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_USER_GROUPS,
  'app-admin-caper-billing': URL_APP_ADMIN_CAPER_BILLING,
  'app-admin-caper-billing-upload': URL_APP_ADMIN_CAPER_BILLING_UPLOAD,
  'app-admin-caper-billing-history': URL_APP_ADMIN_CAPER_BILLING_HISTORY,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
